import { Injectable } from '@angular/core';
import { AppService } from '../shared/app.service';
import { IZittingDb } from '../shared/offline/cobradb';
import { HttpClient, HttpParams } from '@angular/common/http';
import { state2 } from '../shared/state';
import { of } from 'rxjs';

@Injectable()
export class ArchiefService {

  constructor(private http: HttpClient, private appService: AppService) { }

  getZittingen(jaar: number, soortZittingId: number) {
    if (!jaar) { return of([] as IZittingDb[]); }
    const vanIncl = new Date(jaar, 0, 1).toISOString();
    const totExcl = new Date(jaar + 1, 0, 1).toISOString();
    let params = new HttpParams()
      .set('vanIncl', vanIncl)
      .set('totExcl', totExcl);
    if (soortZittingId > 0) {
      params = params.set('soortZittingId', soortZittingId.toString());
    }
    const url = this.appService.getUrl(`api/zitting/getzittingen`);
    return this.http.post<IZittingDb[]>(url, {}, { params });
  }

}
